module.exports = __webpack_public_path__ + "static/fe_icon2-1cad9dfb00d74f1ddbbcecd44b1e1d9e.png";